import React, { memo, useState } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { array, bool, object, shape, string, arrayOf } from 'prop-types'

import MenuButton from './Components/MenuButton/MenuButton'

let Assets3DCategories
let Assets3DPrintCategories
let CommunityDropdown

function Menu({
  isActive = false,
  mainMenuItems,
  communityLinks,
  printableCategories,
  assetCategories,
  extractingCoreStyles = false,
  byType,
  locale = 'en',
  budgetsData,
  actionsConfig,
}) {
  const [activeDropdown, setActiveDropdown] = useState(null)
  const [isAssets3DCategoriesLoaded, setIsAssets3DCategoriesLoaded] = useState(false)
  const [isCommunityDropdownLoaded, setIsCommunityDropdownLoaded] = useState(false)
  const [isAssets3DPrintCategoriesLoaded, setIsAssets3DPrintCategoriesLoaded] = useState(false)

  const menuItems = Object.keys(mainMenuItems)

  function handleWidgetLoad(widgetId, callback) {
    if (widgetId === 'navigation-3d-models' && !Assets3DCategories && !isAssets3DCategoriesLoaded) {
      import('Pods/LazyLoaded/Assets3DCategories/Assets3DCategories')
        .then((module) => {
          Assets3DCategories = module.default
          setIsAssets3DCategoriesLoaded(true)
          callback?.()
        })
        .catch((error) => {
          console.error('Failed to load Assets3DCategories:', error)
        })
    }

    if (widgetId === 'navigation-community' && !CommunityDropdown && !isCommunityDropdownLoaded) {
      import('Pods/LazyLoaded/CommunityDropdown/CommunityDropdown')
        .then((module) => {
          CommunityDropdown = module.default
          setIsCommunityDropdownLoaded(true)
          callback?.()
        })
        .catch((error) => {
          console.error('Failed to load CommunityDropdown:', error)
        })
    }

    if (widgetId === 'navigation-3d-print' && !Assets3DPrintCategories && !isAssets3DPrintCategoriesLoaded) {
      import('Pods/LazyLoaded/Assets3DPrintCategories/Assets3DPrintCategories')
        .then((module) => {
          Assets3DPrintCategories = module.default
          setIsAssets3DPrintCategoriesLoaded(true)
          callback?.()
        })
        .catch((error) => {
          console.error('Failed to load Assets3DPrintCategories:', error)
        })
    }
  }

  const isLoaded = {
    models: isAssets3DCategoriesLoaded && !!Assets3DCategories,
    community: isCommunityDropdownLoaded && !!CommunityDropdown,
    printable: isAssets3DPrintCategoriesLoaded && !!Assets3DPrintCategories,
  }

  const menuDropdowns = {
    models: isLoaded.models ? (
      <Assets3DCategories
        assetCategories={assetCategories?.itemCategories || []}
        byType={byType}
        locale={locale}
        budgets={budgetsData.assetsBudgets}
        baseUrl={budgetsData.assetsBaseUrl}
        actionsConfig={actionsConfig}
      />
    ) : null,
    community: isLoaded.community ? (
      <CommunityDropdown communityLinks={communityLinks} locale={locale} />
    ) : null,
    printable: isLoaded.printable ? (
      <Assets3DPrintCategories
        categories={printableCategories.itemCategories}
        locale={locale}
        budgets={budgetsData.printableAssetsBudgets}
        baseUrl={budgetsData.printableBaseUrl}
        actionsConfig={actionsConfig}
      />
    ) : null,
  }

  return (
    <ul
      className={classnames(
        'app-nav fast-options-dropdowns',
        isActive && 'is-opened',
        'new_navbar_ui',
      )}
    >
      {menuItems.map((menuItem, i) => {
        const hasDropdownForItem = !!menuDropdowns[menuItem]
          || menuItem === 'models'
          || menuItem === 'community'
          || menuItem === 'printable'

        return (
          <MenuButton
            key={`menu-item-${i}`}
            activeDropdown={activeDropdown}
            setActiveDropdown={setActiveDropdown}
            menuItem={mainMenuItems[menuItem]}
            dropdownComponent={menuDropdowns[menuItem]}
            isDropdownLoaded={isLoaded[menuItem]}
            hasDropdown={hasDropdownForItem}
            onWidgetLoad={handleWidgetLoad}
            showIcon={false}
            extractingCoreStyles={extractingCoreStyles}
            actionsConfig={actionsConfig}
          />
        )
      })}
    </ul>
  )
}

Menu.propTypes = {
  communityLinks: array.isRequired,
  isActive: bool,
  mainMenuItems: object.isRequired,
  printableCategories: object.isRequired,
  assetCategories: object.isRequired,
  extractingCoreStyles: bool,
  byType: arrayOf(shape({
    icon: string,
    name: string,
    path: string,
  })).isRequired,
  locale: string,
  budgetsData: shape({
    assetsBaseUrl: string.isRequired,
    printableBaseUrl: string.isRequired,
    assetsBudgets: arrayOf(shape({
      title: string.isRequired,
      path: string.isRequired,
      icon: string.isRequired,
      withSub: bool,
    })).isRequired,
    printableAssetsBudgets: arrayOf(shape({
      title: string.isRequired,
      path: string.isRequired,
      icon: string.isRequired,
      withSub: bool,
    })).isRequired,
  }).isRequired,
  actionsConfig: shape({
    subscriptionMenuEnabled: bool,
    subscriptionFlowEnabled: bool,
    isActiveSubscriber: bool,
  }).isRequired,
}

export default memo(Menu)
